import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";

import "./_public.css";
import logo from "../logo.svg";

class Public extends Component {
  render() {
    const toLogin = props => <Link to="/auth/login" {...props} />;
    const toRegister = props => <Link to="/auth/register" {...props} />;
    return (
      <div className="screen home-cntr-screen">
        <div className="home-cntr">
          <div className="home-icon-cntr">
            <img src={logo} className="App-logo" alt="logo" />
          </div>
          <div className="home-app-title-cntr">
            <Typography variant="title" className="home-app-title" gutterBottom>
              Channel Illumine - Drip Irrigation of Your Cognition
            </Typography>
          </div>
          <div className="link-cntr">
            <div>
              <Button
                variant="outlined"
                size="medium"
                className="public_outlinedButtons"
                component={toLogin}
              >
                Login
              </Button>
            </div>
            <div>
              <Button
                variant="outlined"
                size="medium"
                className="public_outlinedButtons"
                component={toRegister}
              >
                Register
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Public;



// WEBPACK FOOTER //
// ./src/routes/Public.js